<template>
  <div style="display: inline; text-align: left">
    <el-dialog width="1000px" top="10vh" title="导入记录" :visible.sync="dialogVisible">
      <el-table :data="historyList" class="table" v-loading="tableLoading">
        <el-table-column prop="CTime" label="导入时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.CTime | handleTime }}
          </template>
        </el-table-column>
        <el-table-column prop="Operator" label="导入人员"></el-table-column>
        <el-table-column prop="RosterName" label="名单"></el-table-column>
        <el-table-column prop="AddNum" label="新增"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.Status) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Type" label="类型">
          <template slot-scope="scope">
            {{ scope.row.Type | getTypeStr }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="openDetail(scope.row)"
              :disabled="scope.row.Status !== 2"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--内层的dialog-->
      <el-dialog width="800px" top="15vh" :visible.sync="dialogInnerVisible" append-to-body>
        <el-table
          v-if="rosterType === 0"
          :data="detailUserList"
          class="table-inner"
          v-loading="tableInnerLoading"
        >
          <el-table-column prop="UserId" label="用户ID"></el-table-column>
          <el-table-column prop="UserType" label="用户类型"></el-table-column>
          <el-table-column prop="Name" label="姓名"></el-table-column>
          <el-table-column prop="UserCode" label="医生编码"></el-table-column>
          <el-table-column prop="Hospital" label="医院"></el-table-column>
          <el-table-column prop="Department" label="科室"></el-table-column>
          <el-table-column prop="Title" label="职称"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.Status | handleStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="rosterType === 1"
          :data="detailUserList"
          class="table-inner"
          v-loading="tableInnerLoading"
        >
          <el-table-column prop="OpenId" label="OpenId"></el-table-column>
        </el-table>
        <div style="text-align: right">
          <el-pagination
            style="background-color: #ffffff; width: 100%"
            layout="total, prev, sizes, pager, next"
            :total="innerPageTotal"
            :page-sizes="g_pageSizesConfig"
            :page-size="innerPageSize"
            :current-page="innerPageIndex"
            @current-change="changeInnerPageIndex"
            @size-change="changeInnerPageSize"
          />
        </div>
      </el-dialog>
      <div style="text-align: right">
        <el-pagination
          style="background-color: #ffffff; width: 100%"
          layout="total, prev,sizes, pager, next, jumper"
          :total="pageTotal"
          :page-sizes="g_pageSizesConfig"
          :page-size="pageSize"
          :current-page="pageIndex"
          @current-change="changePageIndex"
          @size-change="changePageSize"
        />
      </div>
    </el-dialog>
    <el-button @click="dialogVisible = true" style="margin-left: 10px">导入记录</el-button>
  </div>
</template>

<script>
import { GetRosterRecordList, GetRosterRecordInfo } from '@/api/roster';
const TypeMap = {
  0: '医生名单',
  1: '粉丝名单',
};
export default {
  name: 'PublishImportHistory',
  filters: {
    handleStatus(status) {
      // console.log(status);
      switch (status) {
        case 1:
          return '可发送';
        case 2:
          return '已删除';
        case 3:
          return '已取关';
        default:
          return '-';
      }
    },
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
    getTypeStr(type) {
      return TypeMap[type] || '';
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogInnerVisible: false,

      historyList: [],
      detailUserList: [],

      rosterType: 0,

      pageSize: 10,
      pageIndex: 1,
      pageTotal: 1,

      innerRosterId: '',
      innerPageSize: 10,
      innerPageIndex: 1,
      innerPageTotal: 1,

      tableLoading: false,
      tableInnerLoading: false,
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.changePageIndex(1);
        }
      },
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      GetRosterRecordList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
      })
        .then((res) => {
          this.pageTotal = res.Total;
          this.historyList = res.Records;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getList();
    },
    changeInnerPageIndex(val) {
      this.innerPageIndex = val;
      this.getDetail();
    },
    changeInnerPageSize(val) {
      this.innerPageSize = val;
      this.getDetail();
    },
    openDetail(item) {
      this.dialogInnerVisible = true;
      this.innerPageIndex = 1;
      this.innerRosterId = item.RecordId;
      this.getDetail();
    },
    getDetail() {
      GetRosterRecordInfo({
        RecordId: this.innerRosterId,
        PageIndex: this.innerPageIndex,
        PageSize: this.innerPageSize,
      })
        .then((res) => {
          this.detailUserList = res.Users;
          this.rosterType = res.RecordInfo.Type;
          this.innerPageTotal = res.Total;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return '导入中';
        case 2:
          return '导入成功';
        case 3:
          return '导入失败';
        default:
          return '-';
      }
    },
  },
};
</script>

<style scoped>
.table {
  height: 700px;
  overflow-y: scroll;
}
.table-inner {
  height: 600px;
  overflow-y: scroll;
}
</style>
